import { render } from "./DatasetMethodForm.vue?vue&type=template&id=4029277f"
import script from "./DatasetMethodForm.vue?vue&type=script&lang=js"
export * from "./DatasetMethodForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__